"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhileLoopComponentParameters = void 0;
exports.WhileLoopComponentParameters = [
    {
        id: 'condition',
        label: 'Loop condition',
        description: 'Input Param - The loop executes while this condition is true',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'output',
        label: 'Output',
        description: 'Output Param - Array of outputs of loop component',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=WhileLoop.js.map